"use client";

import { c as _c } from "react/compiler-runtime";
import { AcceptTermsFlow } from "./AcceptTermsFlow";
import { AuthenticateFlow } from "./AuthenticateFlow/AuthenticateFlow";
import { BottomSheetFlows } from "./BottomSheetFlows/BottomSheetFlows";
import { ConnectFlow } from "./ConnectFlow/ConnectFlow";
import { ModalFlows } from "./ModalFlows/ModalFlows";
import { SideSheetFlows } from "./SideSheetFlows/SideSheetFlows";
export const FlowHandler = t0 => {
  const $ = _c(9);
  const {
    acceptTermsEnabled
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ConnectFlow />;
    t2 = <AuthenticateFlow />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== acceptTermsEnabled) {
    t3 = acceptTermsEnabled && <AcceptTermsFlow />;
    $[2] = acceptTermsEnabled;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SideSheetFlows />;
    t5 = <BottomSheetFlows />;
    t6 = <ModalFlows />;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3) {
    t7 = <>{t1}{t2}{t3}{t4}{t5}{t6}</>;
    $[7] = t3;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};